import { Component, OnInit } from "@angular/core";
import { Input } from "@angular/core";

@Component({
    selector: "dodo-label",
    templateUrl: "./label.component.html",
    styleUrls: ["./label.component.scss"],
    standalone: false
})
export class LabelComponent implements OnInit {
	@Input() text: String;
	@Input() prefix: String;
	@Input() suffix: string;

	constructor() {}

	ngOnInit() {}
}
